import { Link } from '@tanstack/react-router'

export default function Pagination({
  page,
  totalPages,
  to,
  params = {},
  filters = {},
}: {
  page: number
  totalPages: number
  to: '/blog' | '/blog/tag/$tag' | '/blog/$category'
  params?: { tag?: string; category?: string }
  filters?: { tag?: string; category?: string }
}) {
  if (totalPages <= 1) return null
  const link = (target: number, label: string, current = false) => (
    <Link
      key={label}
      to={to}
      params={params}
      search={{ ...filters, page: target === 1 ? undefined : target }}
      aria-current={current ? 'page' : undefined}
      className={`focus-ring px-4 py-3 ${current ? 'bg-sage-200 text-forest-strong' : 'text-sage-200 hover:bg-white/5'}`}
    >
      {label}
    </Link>
  )
  return (
    <nav
      aria-label="Article pagination"
      className="preview-mono mt-10 flex flex-wrap items-center gap-2 text-sm"
    >
      {page > 1 && link(page - 1, 'Previous')}
      {Array.from({ length: totalPages }, (_, index) => index + 1)
        .filter((n) => n === 1 || n === totalPages || Math.abs(n - page) <= 2)
        .map((n, index, pages) => (
          <span key={n} className="inline-flex items-center">
            {index > 0 && n - pages[index - 1] > 1 && (
              <span aria-hidden="true" className="px-2">
                …
              </span>
            )}
            {link(n, String(n), n === page)}
          </span>
        ))}
      {page < totalPages && link(page + 1, 'Next')}
    </nav>
  )
}
